// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
import {z} from 'zod';

export const RecordSchema = z.object({
    amount: z.number({invalid_type_error: 'Required'}),
    pricingModel: z.string().min(1, 'Required'),
    billingPeriod: z.string().min(1, 'Required'),
});
